import "./index.css";
import { APITester } from "./APITester";
import { Card, CardContent } from "@/components/ui/card";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";

import poukaz from "./poukaz.svg";
import React from "react";
import { Button } from "./components/ui/button";

export function App() {
  const { width, height } = useWindowSize();
  const [run, setRun] = React.useState(false);
  return (
    <div
      onClick={() => setRun(true)}
      className="h-screen-dvh w-screen-dwh flex flex-col justify-center items-center overflow-hidden"
    >
      <Confetti
        width={width}
        height={height}
        run={run}
        numberOfPieces={100}
        tweenDuration={10000}
      />
      <div className="container mx-auto p-8 text-center relative z-10 flex flex-col">
        <p className="uppercase text-3xl font-bold bg-gradient-to-r from-slate-900 via-orange-400 to-slate-900 inline-block text-transparent bg-clip-text">
          Všechno nejlepší k 30 narozeninám!!
        </p>
        <img
          src={poukaz}
          alt="poukaz"
          className="h-64 mt-4 max-w-full object-contain"
        />
      </div>
      <a
        href="https://pub-97bf7f70335c49e1876e4f6ce108026c.r2.dev/lucka-voucher.png"
        download="voucher.png"
      >
        <Button onClick={() => {}}>stahnout voucher</Button>
      </a>
      <p className="mt-2">
        odkaz na{" "}
        <a
          href="https://www.headspastudio.cz/"
          target="_blank"
          className="text-blue-500"
        >
          studio
        </a>
      </p>
      <p className="italic text-sm"></p>
    </div>
  );
}

export default App;
